import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { colorsNew } from 'root/src/client/web/commonStyles'
import { styledSimpleButton } from './style'

const ACTIVE_BACKGROUND_COLOR = colorsNew.dark2
const ACTIVE_COLOR = '#fff'

const Button = memo(({ title, backgroundColor, color, onClick, active, classes }) => {
	const bgColor = active ? ACTIVE_BACKGROUND_COLOR : backgroundColor
	const textColor = active ? ACTIVE_COLOR : color
	return (
		<button
			type="button"
			className={classes.button}
			onClick={onClick}
			style={{
				backgroundColor: bgColor,
				color: textColor,
			}}
		>
			{title}
		</button>
	)
})

Button.defaultProps = {
	backgroundColor: '#fff',
	color: '#000',
	onClick: null,
}

export default withStyles(styledSimpleButton, { name: 'MusButton' })(Button)
